/**
 * Query keys do domínio auth (apps/crm, apps/public, apps/admin, apps/sales).
 *
 * Cobre sessão atual, perfil do usuário logado, role/membership e
 * approvals admin (clubes pendentes, owner requests).
 */
import { tuple } from "./core";

const root = ["auth"] as const;

const admin = {
  all: tuple(root, "admin"),
  clubsPending: tuple(root, "admin", "clubs-pending-approval"),
  ownerRequestsPending: tuple(root, "admin", "club-owner-requests-pending"),
} as const;

export const auth = {
  all: root,
  session: tuple(root, "session"),
  user: tuple(root, "user"),
  /** Memberships / roles do usuário em organizações ou clubes. */
  memberships: (userId: string | null | undefined) =>
    tuple(root, "memberships", userId),
  /** RPC `is_network_admin(user, club)` — por clube, não só o clube ativo. */
  isNetworkAdmin: (userId: string | null | undefined, clubId: string | null | undefined) =>
    tuple(root, "is-network-admin", userId ?? null, clubId ?? null),
  admin,
} as const;
